import { Request } from '../../Servidor/Request';

export class PedologyRequest{
    private sgeppedologia: number;
    private nome: string;

	constructor(sgeppedologia: number, nome: string) {
		this.sgeppedologia = sgeppedologia;
		this.nome = nome;
	}


    /**
     * Getter sgeppedologia
     * @return {number}
     */
	public getSgeppedologia(): number {
		return this.sgeppedologia;
	}

    /**
     * Getter nome
     * @return {string}
     */
	public getNome(): string {
		return this.nome;
	}
}

export class PedologyStructRequest {
    private sgeppedologia: number;

	constructor(sgeppedologia: number) {
        this.sgeppedologia = sgeppedologia;
	}


    /**
     * Getter sgeppedologia
     * @return {number}
     */
	public getSgeppedologia(): number {
		return this.sgeppedologia;
	}

}

export class PedologyStructResponse {
    private sgeppedologia: number;
    private nome: string;

	constructor(sgeppedologia: number, nome: string) {
		this.sgeppedologia = sgeppedologia;
		this.nome = nome;
	}


    /**
     * Getter sgeppedologia
     * @return {number}
     */
	public getSgeppedologia(): number {
		return this.sgeppedologia;
	}

    /**
     * Getter nome
     * @return {string}
     */
	public getNome(): string {
		return this.nome;
	}
}

export class PedologyInteractor {
    public fetchSave(request: PedologyRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("propriedade/pedologia/salvar", request).then((rs) => {
                if(rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                let response = rs.Status == "Sucesso"
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: PedologyStructRequest): PromiseLike<PedologyStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("propriedade/pedologia/buscar", request).then((rs) => {
                if(rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}